import TabsAntd from 'antd/es/tabs';

export default TabsAntd;